"use client";

import { authInfo, authLogout } from "@/entities";
import { useMutation, useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/navigation";

export function DropdownProfile() {
  const router = useRouter();

  const logoutMutation = useMutation({
    mutationFn: authLogout,
    onSuccess: () => {
      // router.push("/app/main");
      window.location.href = "/app/main";
    },
    onError: (error) => {
      console.error(error);
    },
  });
  const onLogout = () => {
    if (!confirm("로그아웃 하시겠습니까?")) return;
    if (logoutMutation.isPending) return;
    logoutMutation.mutate();
  };

  const { error, isLoading, data } = useQuery({
    queryKey: ["authInfo"],
    queryFn: authInfo,
  });

  if (isLoading) return <></>;
  if (error) return <></>;

  return (
    <div className="navbar-item navbar-user dropdown">
      <a
        href="#"
        className="navbar-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
      >
        <div className="image image-icon bg-gray-800 text-gray-600">
          <i className="fa fa-user"></i>
        </div>
        <span>
          <span className="d-none d-md-inline fw-bold">
            {data?.result?.name}
          </span>
          <b className="caret"></b>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <Link
          href={{
            pathname: `/admin/users/${data?.result?.id}`,
          }}
          className="dropdown-item"
        >
          프로필 수정
        </Link>
        {/* <Link
          href="/email/inbox"
          className="dropdown-item d-flex align-items-center"
        >
          Inbox
          <span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
        </Link>
        <Link href="/calendar" className="dropdown-item">
          Calendar
        </Link>
        <Link href="/extra/settings-page" className="dropdown-item">
          Settings
        </Link>
        <div className="dropdown-divider"></div> */}
        <button
          onClick={onLogout}
          className="dropdown-item"
          disabled={logoutMutation.isPending}
        >
          로그아웃
        </button>
      </div>
    </div>
  );
}
